module.exports = __webpack_public_path__ + "img/my_archive_check.55ce7cde.svg";